import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';

@Component({
	selector: 'card',
	templateUrl: 'card.html',
})
export class Card implements OnInit {
	@Input('type') type;
	@Input('data') data;
	@ViewChild("training") trainingTpl: TemplateRef<any>;
	tpl;

	ngOnInit() {
		this.tpl = {
			training: this.trainingTpl
		}
	}
}
